import type { DropdownItem } from "@carbon6/c6-frontend-design";
import type { Member, WorkspaceDrift, WorkspaceRemapChangedField } from "@/api";

// 동기화 확인 화면의 순수 표시 헬퍼. 패널은 이 함수들만 호출한다. 그래서 패널이 얇게 유지된다.

// 전체 멤버 목록 → 피커 옵션. 목록이 작다. 그래서 패널에서 1회 만들어 재사용한다.
// 이 함수는 시스템 Member 를 옵션에서 뺀다. 시스템 Member 는 training API 를 부를 수 없다. 그래서
// workspace 소유자로 두지 않는다. BE 도 시스템 Member 를 대상으로 한 선점 부여와 소유자 이전을
// 거부한다(403 `member.system_account`).
export function buildMemberOptions(members: readonly Member[]): DropdownItem[] {
  return members
    .filter((member) => member.account_type !== "system")
    .map((member) => ({ value: member.uuid, label: member.display_name }));
}

function shortId(id: string): string {
  return `${id.slice(0, 8)}…`;
}

// snapshot ↔ live 어긋남 표기. 이름 축은 이름 그대로, group 축은 uuid 단축으로 보여준다.
// live 가 없으면(missing 버킷) 화살표 우변을 "삭제되었습니다."으로 표기한다.
export function driftDiffLabel(drift: WorkspaceDrift, axis: "name" | "group"): string {
  if (axis === "name") {
    const before = drift.snapshot.name ?? "—";
    const after = drift.live === null ? "삭제되었습니다." : (drift.live.name ?? "—");
    return `${before} → ${after}`;
  }
  const before = shortId(drift.snapshot.group_id);
  const after = drift.live === null ? "삭제되었습니다." : shortId(drift.live.group_id);
  return `${before} → ${after}`;
}

const CHANGED_FIELD_LABELS: Record<WorkspaceRemapChangedField, string> = {
  owner: "소유자",
  display_name: "표시명",
  "snapshot.name": "스냅샷 이름",
  "snapshot.group_id": "스냅샷 그룹",
};

// remap 응답의 changed_fields → 토스트 요약. 빈 배열은 이미 live 와 일치했다는 뜻이다.
export function remapResultMessage(fields: readonly WorkspaceRemapChangedField[]): string {
  if (fields.length === 0) {
    return "이미 최신 상태라 변경 사항이 없습니다.";
  }
  const labels = fields.map((field) => CHANGED_FIELD_LABELS[field]);
  return "재매핑을 완료했습니다. " + labels.join(" · ") + " 항목을 갱신했습니다.";
}
